export default {
  __name: 'AbSelectorButton',
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    clubCard: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var icon = computed(function () {
      if (props.isSelected) {
        return 'circle-check';
      }
      return 'circle';
    });
    return {
      __sfc: true,
      props: props,
      icon: icon
    };
  }
};